import { useEffect } from 'react'
import { KEY_CODE_MAP } from 'Defaults'

const useExitOnEsc = ({ enableExitOnEsc, onEsc }) => {
  useEffect(() => {
    const eventHandler = (e) => {
      if(e.keyCode === KEY_CODE_MAP.ESC && enableExitOnEsc) {
        onEsc()
      }
    }
    document.addEventListener('keyup', eventHandler)
    return () => document.removeEventListener('keyup', eventHandler)
  }, [enableExitOnEsc])
}

export default useExitOnEsc
